import { createSlice } from '@reduxjs/toolkit';

const myBrandSlice = createSlice({
  name: 'myBrand',
  initialState: {
    loading: false,
    error: null,
    name: '',
    tradeName: '',
    brandLogo: '',
    pocName: '',
    pocMobile: '',
    brandGst: '',
    description: '',
    sellers: [],
  },
  reducers: {
    // Loading states
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearError: (state) => {
      state.error = null;
    },

    // Brand management
    addBrand: (state, action) => {
      const {
        _id: brandId,
        name,
        tradeName,
        brandLogo,
        pocName,
        pocMobile,
        brandGst,
        description,
        sellers = [],
      } = action.payload;
      state.name = name || '';
      state.tradeName = tradeName || '';
      state.brandLogo = brandLogo || '';
      state.pocName = pocName || '';
      state.pocMobile = pocMobile || '';
      state.brandGst = brandGst || '';
      state.description = description || '';
      state.loading = false;
      state.error = null;
      state.sellers = sellers;
      state.brandId = brandId;
    },

    updateBrandInfo: (state, action) => {
      const updates = action.payload;
      Object.keys(updates).forEach((key) => {
        if (key in state && key !== 'sellers') {
          state[key] = updates[key];
        }
      });
    },

    clearBrand: (state) => {
      state.name = '';
      state.tradeName = '';
      state.brandLogo = '';
      state.pocName = '';
      state.pocMobile = '';
      state.brandGst = '';
      state.description = '';
      state.sellers = [];
      state.error = null;
      state.brandId = '';
    },

    addSeller: (state, action) => {
      const seller = {
        id: action.payload.id || Date.now().toString(),
        ...action.payload,
      };
      state.sellers.push(seller);
    },

    setSellers: (state, action) => {
      state.sellers = Array.isArray(action.payload) ? action.payload : [];
    },

    clearSellers: (state) => {
      state.sellers = [];
    },
    // Toggle seller status (if applicable)
    // toggleSellerStatus: (state, action) => {
    //   const sellerId = action.payload
    //   const seller = state.sellers.find(seller => seller.id === sellerId)
    //   if (seller && 'active' in seller) {
    //     seller.active = !seller.active
    //   }
    // },
  },
});

export const {
  setLoading,
  setError,
  clearError,
  addBrand,
  updateBrandField,
  updateBrandInfo,
  clearBrand,
  addSeller,
  setSellers,
  clearSellers,
  // toggleSellerStatus,
} = myBrandSlice.actions;

export default myBrandSlice.reducer;
